import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Modal,
  Input,
  Button,
  Typography,
  Collapse,
  Spin,
  List,
  Form,
} from 'antd'
import { LoadingOutlined, UserOutlined } from '@ant-design/icons'
import { ROW_JUSTIFY, COL_SPAN, AvatarColorsArr } from '../common/const'
import {
  getRedirectUrl,
  OpenBrowserUrl,
  getTeamAvatarStr,
  CheckSystem,
} from '../common/globalFun'
import {
  GetInviteList,
  GetLoginStatus,
  PostInviteHandle,
  PostTeamOpen,
  GetTeamList,
  PostGetLoginKey,
} from '../config/request'
import { useIntl } from 'react-intl'
import PageBg from '../components/PageBg'

import './css/style.css'

const { Title, Text } = Typography
const { Panel } = Collapse

const antIcon = <LoadingOutlined style={{ fontSize: 30 }} spin />

const InviteList = (props) => {
  const { history } = props
  const intl = useIntl()
  const [form] = Form.useForm()

  const [initLoading, setInitLoading] = useState(true)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [inviteList, setInviteList] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [confirmJoinTeam, setConfirmJoinTeam] = useState()

  const onFinish = (values) => {
    console.log(values)
    setSubmitLoading(true)
    const name = values.name
    join(name)
      .then(() => {
        if (CheckSystem.Felo()) {
          PostGetLoginKey({
            account: confirmJoinTeam.email,
            teamId: confirmJoinTeam.team_id,
          }).then((loginKey) => {
            props.setGlobalLoginKey(loginKey)
            history.push('/download')
          })
        } else {
          PostTeamOpen({
            account: confirmJoinTeam.email,
            teamIds: [confirmJoinTeam.team_id],
          }).then(() => {
            OpenBrowserUrl(
              getRedirectUrl() + `?team_id=${confirmJoinTeam.team_id}`,
              '_blank'
            )
          })
        }
      })
      .finally(() => {
        setSubmitLoading(false)
      })
  }

  const toogleModalVisible = () => {
    setModalVisible(!modalVisible)
  }

  const skip = () => {
    const { data } = props.location
    if (data && data.nextPath) {
      history.push(data.nextPath)
    } else {
      GetLoginStatus({ status_type: 'register' }).then((data) => {
        const { status, accountList } = data
        let nextPath = ''
        switch (Number(status)) {
          case 0:
          case 2:
            nextPath = '/signin_org'
            break
          default:
            break
        }
        props.setGlobalEmail(accountList[0])

        GetTeamList().then((teams) => {
          // 判断是否有组织
          if (
            teams &&
            teams.length &&
            teams[0].teams &&
            teams[0].teams.length
          ) {
            history.push('/team_list')
          } else {
            history.push(nextPath)
          }
        })
      })
    }
  }

  const confirmJoin = (team) => {
    setConfirmJoinTeam(team)
    toogleModalVisible()
  }

  const join = (name) => {
    return new Promise((resolve, reject) => {
      PostInviteHandle({
        username: name,
        account: confirmJoinTeam.email,
        accept: true,
        invite_id: confirmJoinTeam.id,
      })
        .then(() => {
          const list = inviteList.filter((item) => {
            return item.id != confirmJoinTeam.id
          })
          setInviteList(list)
          resolve()
        })
        .catch(() => {
          reject()
        })
    })
  }

  const notJoin = (team) => {
    PostInviteHandle({
      username: 'username',
      account: team.email,
      accept: false,
      invite_id: team.id,
    }).then(() => {
      const list = inviteList.filter((item) => {
        return item.id != team.id
      })
      setInviteList(list)
      if (!list.length) {
        skip()
      }
    })
  }

  const translateInviteList = (list) => {
    const teamList = []
    list.map((item) => {
      item.team_invites.map((team) => {
        const avatarColor =
          AvatarColorsArr[~~team.team_id % AvatarColorsArr.length]
        team.avatar = (
          <div
            className="card-avatar"
            style={{ backgroundColor: avatarColor ? avatarColor : '#616061' }}
          >
            {getTeamAvatarStr(team.team_name)}
          </div>
        )
        teamList.push(team)
      })
    })
    return teamList
  }

  const getInviteList = () => {
    GetInviteList()
      .then((data) => {
        if (data && data.length) {
          const teamList = translateInviteList(data)
          setInviteList(teamList)
          props.setGlobalAccount(data[0].account)
        }
      })
      .finally(() => {
        setInitLoading(false)
      })
  }

  useEffect(() => {
    getInviteList()
  }, [])

  return (
    <>
      <PageBg />
      <Row
        justify={ROW_JUSTIFY}
        align="middle"
        className={`height-full select-corp-page`}
      >
        <Col span={COL_SPAN} className="content-center">
          {initLoading ? (
            <Spin indicator={antIcon} />
          ) : (
            <>
              <Title level={3} className="content-center mb-50">
                {inviteList.length
                  ? intl.formatMessage({ id: 'invite.list' })
                  : intl.formatMessage({ id: 'not.invite' })}
              </Title>
              <section>
                {!!inviteList.length && (
                  <List
                    bordered
                    size="large"
                    dataSource={inviteList}
                    renderItem={(item) => (
                      <List.Item
                        actions={[
                          <Button
                            className="btn-danger"
                            onClick={() => {
                              notJoin(item)
                            }}
                          >
                            {intl.formatMessage({ id: 'not.join' })}
                          </Button>,
                          <Button
                            type="primary"
                            onClick={() => {
                              confirmJoin(item)
                            }}
                          >
                            {intl.formatMessage({ id: 'join' })}
                          </Button>,
                        ]}
                      >
                        <Row
                          wrap={false}
                          align="middle"
                          gutter={[15, 10]}
                          title={item.team_name}
                        >
                          <Col>
                            <div className={`card-wrap`}>{item.avatar}</div>
                          </Col>
                          <Col className="card-name">
                            <Title level={5} className="invite-team-name">
                              {item.team_name}
                            </Title>
                          </Col>
                        </Row>
                      </List.Item>
                    )}
                  />
                )}
              </section>
              <section
                className={`mt-50 content-center`}
                hidden={!inviteList.length}
              >
                <Button type="link" onClick={skip}>
                  {intl.formatMessage({ id: 'skip' })}
                </Button>
              </section>
            </>
          )}
        </Col>
      </Row>

      <Modal
        centered
        destroyOnClose
        title={`${intl.formatMessage({ id: 'join.org' })} - ${
          confirmJoinTeam && confirmJoinTeam.team_name
        }`}
        visible={modalVisible}
        onOk={form.submit}
        onCancel={toogleModalVisible}
        afterClose={() => {
          form.resetFields()
        }}
        confirmLoading={submitLoading}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="name"
            rules={[{ required: true, message: '' }]}
            label={intl.formatMessage({ id: 'label.join.org.set.name' })}
          >
            <Input autoFocus placeholder="name" maxLength={50} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

const stateProps = (state) => {
  return {
    email: state.email,
  }
}

const dispatchProps = (dispatch) => ({
  setGlobalToken: (token) => {
    dispatch({
      type: 'setToken',
      value: token,
    })
  },
  setGlobalAccount: (account) => {
    dispatch({
      type: 'setAccount',
      value: account,
    })
  },
  setGlobalEmail: (email) => {
    dispatch({
      type: 'setEmail',
      value: email,
    })
  },
  setGlobalLoginKey: (key) => {
    dispatch({
      type: 'setLoginKey',
      value: key,
    })
  },
})

export default connect(stateProps, dispatchProps)(InviteList)
